(() => {
      const text = new Map([
        ['Customer Reviews', 'Kundeanmeldelser'],
        ['Be the first to write a review', 'Vær den første til at skrive en anmeldelse'],
        ['Write a review', 'Skriv en anmeldelse'],
        ['How would you rate this product?', 'Hvordan vil du bedømme dette produkt?'],
        ['We would love it if you would share a bit about your experience.', 'Del gerne lidt om din oplevelse.'],
        ['Review content (Required)', 'Anmeldelse (påkrævet)'],
        ["We'll only contact you about your review if necessary. By submitting your review, you agree to our terms and conditions and privacy policy.", 'Vi kontakter dig kun om din anmeldelse, hvis det er nødvendigt. Når du sender anmeldelsen, accepterer du vilkårene og privatlivspolitikken.'],
        ['About you', 'Om dig'],
        ['Please tell us more about you.', 'Fortæl os lidt om dig.'],
        ['Email address (Required)', 'E-mailadresse (påkrævet)'],
        ['We respect your privacy.', 'Vi respekterer dit privatliv.'],
        ['Display name (Required)', 'Vist navn (påkrævet)'],
        ["This won't be visible to other customers.", 'Dette bliver ikke synligt for andre kunder.'],
        ['Post review as anonymous', 'Send anmeldelsen anonymt'],
        ['Share a picture', 'Del et billede'],
        ['Upload a photo to support your review.', 'Upload et billede til din anmeldelse.'],
        ['Click to upload or drag and drop', 'Klik for at uploade, eller træk filen hertil'],
        ['Back', 'Tilbage'],
        ['Next', 'Næste'],
        ['Submit', 'Send'],
        ['Submit review', 'Send anmeldelse'],
        ['Thanks for your review!', 'Tak for din anmeldelse!'],
        ['We are processing it and it will appear on the store soon.', 'Vi behandler den, og den bliver snart vist i butikken.'],
        ['Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.', 'Bekræft din e-mail via linket, vi netop har sendt. Det hjælper os med at holde anmeldelserne troværdige.'],
        ['Would you like to share your experience of shopping with us?', 'Vil du dele din købsoplevelse med os?'],
        ['We value your feedback and use it to improve. Please share any thoughts or suggestions you have.', 'Din feedback hjælper os med at blive bedre. Del gerne dine tanker og forslag.'],
        ['Close', 'Luk'],
      ]);
      const placeholders = new Map([
        ['Start writing here...', 'Skriv din anmeldelse her...'],
        ['Your email address', 'Din e-mailadresse'],
        ['Display name', 'Vist navn'],
      ]);
      const labels = new Map([
        ['Close review form', 'Luk anmeldelsesformularen'],
        ['Review form pages', 'Sider i anmeldelsesformularen'],
        ['Rating', 'Bedømmelse'],
        ['Privacy and Terms', 'Privatliv og vilkår'],
        ['Review form navigation', 'Navigation i anmeldelsesformularen'],
        ['Previous step', 'Forrige trin'],
        ['Next step', 'Næste trin'],
        ['Share a picture', 'Del et billede'],
      ]);
      const translate = (root) => {
        if (!(root instanceof Element) && root !== document.body) return;
        const selector = '.jdgm-widget, .jdgm-write-review-modal, .jdgm-rev-widg';
        const scopes = root === document.body ? [...document.querySelectorAll(selector)] : [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
        for (const scope of scopes) {
          const nodes = [];
          for (const element of [scope, ...scope.querySelectorAll('*')]) {
            for (const node of element.childNodes) if (node.nodeType === 3) nodes.push(node);
          }
          for (const node of nodes) {
            const value = node.nodeValue.replace(/\s+/g, ' ').trim();
            const replacement = text.get(value);
            if (!replacement) continue;
            const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
            const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
            node.nodeValue = leading + replacement + trailing;
          }
          for (const element of scope.querySelectorAll('[placeholder]')) {
            const replacement = placeholders.get(element.getAttribute('placeholder'));
            if (replacement) element.setAttribute('placeholder', replacement);
          }
          for (const element of scope.querySelectorAll('[aria-label]')) {
            const value = element.getAttribute('aria-label');
            const star = value.match(/^(\d+) stars?$/);
            element.setAttribute('aria-label', star ? star[1] + ' stjerner' : labels.get(value) || value);
            if (star && element.hasAttribute('title')) element.setAttribute('title', star[1] + ' stjerner');
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__gdpr-statement')) {
            if (!element.textContent.includes("We'll only contact you")) continue;
            element.innerHTML = 'Vi kontakter dig kun om din anmeldelse, hvis det er nødvendigt. Når du sender anmeldelsen, accepterer du <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">vilkårene</a> og <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">privatlivspolitikken</a>.';
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__media-upload-prompt')) {
            if (!element.textContent.includes('Click to upload')) continue;
            element.innerHTML = '<b>Klik for at uploade</b>, eller træk filen hertil';
          }
        }
      };
      const run = () => translate(document.body);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
      new MutationObserver(() => run()).observe(document.documentElement, { childList: true, subtree: true });
})();
